export default __webpack_public_path__ + "static/media/camera.d8ffc4b6.svg";